// Default grid height in px
export const GRID_HEIGHT: number = 300;

// Number of columns at the beginning of the grid that are not part of the response data
// (document number, data processing status and extraction id)
export const DEFAULT_COLUMNS_IN_GRID_COUNT: number = 3;

// Shared filter params used across all columns in the grid
export const GRID_FILTER_PARAMS = {
  buttons: ['reset', 'apply'],
  closeOnApply: true,
  suppressMiniFilter: false,
  miniFilterSearchByContains: true,
  maxHeight: 300,
  cellHeight: 32,
  suppressAndOrCondition: true,
} as const;
